import ArgonDashboard from '@/plugins/argon-dashboard';
import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale/lang/pt-br';
import '@/assets/scss/element-theme.scss'; // tema com a cor da marca (substitui theme-chalk/index.css)
import 'element-ui/lib/theme-chalk/display.css';
import '@/assets/scss/element-refinements.scss'; // refinamentos globais (Fase 1) — depois do tema
import moment from 'moment';
import Vue from 'vue';
import VueClipboard from 'vue-clipboard2';
import enums from 'vue-enums';
import VueI18n from 'vue-i18n';
import JsonExcel from 'vue-json-excel';
import VueTheMask, { tokens as vueMaskTokens } from 'vue-the-mask';
import Vue2Filters from 'vue2-filters';
import * as VueGoogleMaps from 'vue2-google-maps';
import App from './App.vue';
import EventBus from './plugin/event.bus.js';
import { i18n } from './plugin/i18n';
import Argon from './plugins/argon-kit';
import router from './routes';
import ApiService from './services/api.services';
import ApiGateway from './services/api.gateway';
import store from './store';

Vue.prototype.$bus = EventBus;
Vue.config.productionTip = false;
Vue.use(ArgonDashboard);
Vue.use(Argon);
Vue.use(VueI18n);
Vue.use(VueClipboard);
Vue.use(ElementUI, { locale });
Vue.use(VueTheMask);
vueMaskTokens.N = { pattern: /[0-9a-zA-Z]/, transform: (v) => v.toLocaleUpperCase() };
Vue.use(enums, { namespace: '$enums' });
Vue.use(Vue2Filters);

Vue.component("downloadExcel", JsonExcel);

Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY');
  }
});

Vue.filter('formatDateHour', function (value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY HH:mm:ss');
  }
});

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCs3kQGGxrjTru42OD2RKvo83hfeNtAoM0',
    libraries: 'places,drawing,visualization,routes',
  },
  installComponents: true,
});

if (process.env.NODE_ENV === 'development') {
  ApiService.init('http://localhost:3000')
  ApiGateway.init('http://localhost:3047')
}
Vue.component('google-map', VueGoogleMaps.Map);
Vue.component('google-map-marker', VueGoogleMaps.Marker);

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),

}).$mount('#app');

